module.exports = __webpack_public_path__ + "static/media/couch_convo.0c0f301d.jpg";